module.exports = __webpack_public_path__ + "img/2.d3b17fc1.png";